"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRuntimeCustomFields = void 0;
var tslib_1 = require("tslib");
exports.getRuntimeCustomFields = function (customFields, formValues, customFieldsConf) {
    if (!customFieldsConf) {
        return customFields;
    }
    return customFieldsConf.reduce(function (fields, conf) {
        var field = customFields.find(function (fieldValue) { return fieldValue.name === conf.id; });
        if (!field) {
            return fields;
        }
        fields.push(tslib_1.__assign(tslib_1.__assign({}, field), { mandatory: !!conf.required, validator: conf === null || conf === void 0 ? void 0 : conf.validator }));
        var dependentFieldsToDisplay = conf.dependentFields &&
            typeof formValues[conf.id] !== 'undefined' &&
            // tslint:disable-next-line: no-non-null-assertion
            conf.dependentFields[formValues[conf.id].toString()];
        if (dependentFieldsToDisplay) {
            fields.push.apply(fields, exports.getRuntimeCustomFields(customFields, formValues, dependentFieldsToDisplay));
        }
        return fields;
    }, []);
};
//# sourceMappingURL=get-runtime-custom-fields.js.map